// extracted by mini-css-extract-plugin
export default {"tooltip":"fp-z","sharingV2":"gp-z","sharingIconsV2":"hp-z","links":"ip-z","link":"jp-z","facebookV2":"kp-z","twitterV2":"lp-z","pinterestV2":"mp-z"};